module.exports = __webpack_public_path__ + "img/regpack-active.06777fb8.svg";